import React, { useEffect, useState } from 'react';

import "./styles.css";


import { getProductsByCount, fetchProductsByFilter } from '../functions/products/index';

//skeleton
import Catalog from '../components/skeleton/Catelog';

import { useSelector, useDispatch } from 'react-redux'

//icons
import { DollarOutlined, DownSquareOutlined, StarOutlined, SearchOutlined } from '@ant-design/icons'

import { Menu, Slider, Checkbox, Typography, Radio } from 'antd';



import Star from "../components/forms/Star"

//import { ProductListing } from "./components/ProductListing";

//lodash
import _ from 'lodash'

//updated ProductListing page
import ProductItems from './components/ProductItems'

//custom hooks
import useDidMountEffect from './useDidMountEffect';


import 'antd/dist/antd.css';

const { SubMenu } = Menu;

const { Text } = Typography;


export default function Product() {
  const [products, setProducts] = useState([]);
  const [color, setColor] = useState("");
  const [colors, setColors] = useState([
    "Black",
    "Brown",
    "Silver",
    "White",
    "Blue",
  ]);
  const [star, setStar] = useState("");


  const [shipping, setShipping] = useState("");

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { search } = useSelector((state) => ({ ...state }));

  const { text } = search;
  //const [text, setText] = useState("");

  const [price, setPrice] = useState([1, 30000]);

  const [ok, setOk] = useState(false);

  //For tabs


  //const { filteredProducts } = useProductContext();


  useEffect(() => {
    loadAllProducts();
  }, []);

  // 1 load products on by default page load
  const loadAllProducts = () => {
    setLoading(true);
    getProductsByCount(1000)
      .then((p) => {
        setLoading(false);
        setProducts(p.data);
        // dispatch({
        //   type: "ADD_TO_PRODUCTDB",
        //   payload: p.data,
        // });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  


  //load products on price range
  // useEffect(() => {
  //   setLoading(true);
  //   priceFilter();
  // }, [ok]);

  useDidMountEffect(() => {
    //console.log("ok to request");
    fetchProducts({ price });
  }, [ok]);

  const fetchProducts = (arg) => {
    //console.log(arg);
    setLoading(true);
    fetchProductsByFilter(arg)
      .then((res) => {
        setProducts(res.data);
        // dispatch({
        //   type: "ADD_TO_PRODUCTDB",
        //   payload: res.data,
        // });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const priceFilter = () => {
    fetchProductsByFilter({ price })
      .then((res) => {
        setProducts(res.data);
        // dispatch({
        //   type: "ADD_TO_PRODUCTDB",
        //   payload: res.data,
        // });
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  const hanldeSlider = (value) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: "" },
    });
    setPrice(value);
    setStar("");
    setShipping("");
    setTimeout(() => {
      setOk(!ok);
    }, 2000);
  };



  //show products by star rating

  const handleStarClick = (num) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: "" },
    });
    setPrice([0, 0]);
    setShipping("");
    setStar(num);
    setLoading(true)
    fetchProducts({ stars: num });
    setLoading(false)
  };
  const showStars = () => (
    <div className="pr-4 pl-4 pb-2" style={{ backgroundColor: "black" }}>
      <Star starClick={handleStarClick} numberOfStars={5} />
      <Star starClick={handleStarClick} numberOfStars={4} />
      <Star starClick={handleStarClick} numberOfStars={3} />
      <Star starClick={handleStarClick} numberOfStars={2} />
    </div>
  );

  //show products based on shipping yes/no
  const showShipping = () => (
    <>
      <Checkbox
        className="pb-2 pl-4 pr-4"
        onChange={handleShippingchange}
        value="Yes"
        checked={shipping === "Yes"}
      >
        Yes
      </Checkbox>

      <Checkbox
        className="pb-2 pl-4 pr-4"
        onChange={handleShippingchange}
        value="No"
        checked={shipping === "No"}
      >
        No
      </Checkbox>
    </>
  );

  const handleShippingchange = (e) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: "" },
    });
    setPrice([0, 0]);
    setStar("");
    setShipping(e.target.value);
    setLoading(true)
    fetchProducts({ shipping: e.target.value });
    setLoading(false)
  };

  //show products based on color
  const showColors = () =>
    colors.map((c) => (
      <Radio
        key={c}
        value={c}
        name={c}
        checked={c === color}
        onChange={handleColor}
        className="pb-1 pl-4 pr-4"
        style={{ backgroundColor: "black", color: "black" }}
      >
        <div style={{ backgroundColor: "black" }}>
          <Text style={{ color: "white", backgroundColor: "black" }}>{c}</Text>
        </div>
      </Radio>
    ));

  const handleColor = (e) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: "" },
    });
    setPrice([0, 0]);
    setStar("");
    setColor(e.target.value);
    setShipping("");
    fetchProducts({ color: e.target.value });
  };

  const handleQueryChange = (e) => {
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: e.target.value },
    });
    setPrice([0, 0]);
    setStar("");
    setColor("");
    setShipping("");
  };
  const handleQuerySubmit = (e) => {
    e.preventDefault();
    const delayed = setTimeout(() => {
      fetchProducts({ query: text });
      if (!text) {
        loadAllProducts();
      }
    }, 300);

    return () => clearTimeout(delayed);
  }

  const handleClear = (e) => {
    e.preventDefault();
    dispatch({
      type: "SEARCH_QUERY",
      payload: { text: "" },
    });
    setPrice([0, 0]);
    setStar("");
    setColor("");
    setShipping("");
    loadAllProducts();
  };

  const handleAddToChart = (product) => {

    //create cart array
    let cart = [];
    if (typeof window !== 'undefined') {
      //if cart is in localstorage GET iT
      if (localStorage.getItem("cart")) {
        cart = JSON.parse(localStorage.getItem("cart"));
      }
      //push new product to cart
      cart.push({
        //spreading the product means we get all the values
        ...product,
        count: 1,
      });
      // remove duplicates
      let unique = _.uniqWith(cart, _.isEqual);
      //save to local storage
      localStorage.setItem("cart", JSON.stringify(unique));

      //show tooltip

      //add tp redux state
      dispatch({
        type: "ADD_TO_CART",
        payload: unique,
      });

      //show cart itmes in side drawer
      dispatch({
        type: "SET_VISIBLE",
        payload: true,
      });
    }
  }


  return (
    <div style={{ backgroundColor: "black" }}>
      <div className="container-fluid" style={{ backgroundColor: "black" }}>
        <div className="row" style={{ backgroundColor: "black", height:"100vh" }}>
            <div className="col-md-3   pt-2" style={{ backgroundColor: "black" }}>
              <br style={{ backgroundColor: "black" }} />
              <h4 style={{ color: "white" }}> Filter</h4>
              <hr style={{ backgroundColor: "black" }} />
              <Menu defaultSelectedKeys={["1", "2", "3", "4", "5"]} mode="inline" style={{ backgroundColor: "black" }}>

                {/* Price */}
                <SubMenu
                  key="1"
                  icon={<DollarOutlined style={{ color: "#f9a701" }} />}
                  style={{ backgroundColor: "black", color: "black" }}
                  title={<Text style={{ color: "white" }}>Price</Text>}
                >
                  <div style={{ backgroundColor: "black" }}>
                    <Slider
                      className="ml-4 mr-4"
                      tipFormatter={(v) => `R${v}`}
                      range
                      value={price}
                      style={{ backgroundColor: "black", color: "black" }}
                      onChange={hanldeSlider}
                      max="30000"
                    />
                  </div>
                </SubMenu>

                {/* stars */}

                <SubMenu
                  key="2"
                  icon={<StarOutlined style={{ color: "#f9a701" }} />}
                  style={{ backgroundColor: "black" }}
                  title={<Text style={{ color: "white" }}>Rating</Text>}
                >
                  <div style={{ maringTop: "-1-px" }}>{showStars()}</div>
                </SubMenu>

                {/* colors */}
                <SubMenu
                  key="5"
                  icon={<DownSquareOutlined style={{ color: "#f9a701" }} />}
                  style={{ backgroundColor: "black" }}
                  title={<Text style={{ color: "white" }}>Colors</Text>}
                >
                  <div style={{ maringTop: "-10px", backgroundColor: "black" }} className="pr-5">
                    {showColors()}
                  </div>
                </SubMenu>

                {/* shipping */}
                {/* <SubMenu
                key="3"
                icon={<DownSquareOutlined />}
                title={<Text>Shipping</Text>}
              >
                <div style={{ maringTop: "-10px" }} className="pr-5">
                  {showShipping()}
                </div>
              </SubMenu> */}

                {/* Search */}

                <SubMenu
                  key="4"
                  icon={<SearchOutlined style={{ color: "#f9a701" }} />}
                  style={{ backgroundColor: "black" }}
                  title={<Text style={{ color: "white" }}>Search</Text>}
                >
                  <div className="col-sm-10 ml-2" style={{ backgroundColor: "black" }}>
                    <input
                      onChange={handleQueryChange}
                      type="search"
                      value={text}
                      className="form-control"
                      placeholder="Search"
                      style={{ backgroundColor: "black" }}
                    />
                    <br style={{ backgroundColor: "black" }} />
                    <br style={{ backgroundColor: "black" }} />
                    <br style={{ backgroundColor: "black" }} />

                    <button
                      type="submit"
                      className="btn btn-raised btn-sm"
                      style={{ backgroundColor: "black" }}
                      onClick={handleQuerySubmit}
                    >
                      {" "}
                      <Text style={{ color: "#f9a701" }}>Search</Text>
                    </button>
                  </div>
                </SubMenu>

                {/* Clear */}

                <Menu.Item>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleClear}
                  >
                    {" "}
                    Clear
                  </button>
                </Menu.Item>
              </Menu>
            </div>

            <div className="col-sm-9 pb-2">
                  {loading ? (
                    <Catalog />
                  ) : products && products.length ? (
                    // <ProductListing filteredProducts={filteredProducts} />

                    <ProductItems
                      products={products}
                      handleAddToChart={handleAddToChart}
                    />
                  ) : (
                    <div className="text-center text-danger bold">
                      COMING SOON! We're working hard to get your favourite Black-Owned Businesses on our platform... visit us again to see our new additions
                    </div>
                  )}
                  {/* {!products && (
              <div className="text-center text-danger bold">
                COMING SOON! We're working hard to get your favourite Black-Owned Businesses on our platform... visit us again to see our new additions
              </div>
            )} */}
            </div>
        </div>
      </div>
    </div>
  );
}
